// src/components/PropertiesSection.js
import React from 'react';
import { Grid, Card, CardMedia, CardContent, Typography, CardActionArea, Box } from '@mui/material';
import zillowListings from './data/zillowListings';

const PropertiesSectionSold = () => (
  <Box sx={{ padding: '50px 1px' }}>
    <Typography variant="h4" align="center" gutterBottom>
      Recently Represented Properties
    </Typography>

    {/* Horizontal scroll container */}
    <Box
      sx={{
        display: 'flex',
        overflowX: 'auto',
        padding: '10px 0',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {/* Cards stacked two vertically */}
      {zillowListings.map((property) => (
        <Box key={property.id} sx={{ minWidth: '300px', marginRight: 2 }}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Card>
                <CardActionArea href={property.zillowLink} target="_blank" rel="noopener noreferrer">
                  <CardContent>
                    <Typography variant="subtitle1" color="textSecondary" align="center">
                      {property.location}
                    </Typography>
                  </CardContent>
                  <CardMedia
                    component="img"
                    height="200"
                    image={property.image}
                    alt={property.title}
                  />
                  <CardContent>
                    <Typography variant="h6" align="center">{property.title}</Typography>
                    <Typography variant='body1' color="blue" align="center">Represented {property.represented}</Typography>
                    <Typography variant="body2" color="textPrimary" align="center">
                      {property.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  </Box>
);

export default PropertiesSectionSold;
